"use client";

import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const navigationBarVariants = cva("", {
  variants: {
    variant: {
      default:
        "rounded-lg border border-black/10 bg-white/30 backdrop-blur-[73px]",
      floating:
        "rounded-lg bg-system-grayscale-00 bg-opacity-80 backdrop-blur-[64px] border-black border border-opacity-10",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

type NavigationBarProps = React.HTMLAttributes<HTMLElement> &
  VariantProps<typeof navigationBarVariants> & {
    leftSection?: React.ReactNode;
    centerSection?: React.ReactNode;
    rightSection?: React.ReactNode;
  };

export function NavigationBar({
  className,
  variant,
  leftSection,
  centerSection,
  rightSection,
  ...props
}: NavigationBarProps) {
  return (
    <nav
      id="yz-nav-bar"
      className={cn(
        navigationBarVariants({ variant }),
        "flex w-full max-w-7xl items-center justify-between px-[22px] py-2",
        className,
      )}
      {...props}
    >
      <div className="flex items-center gap-2">{leftSection}</div>

      <div className="flex justify-center">{centerSection}</div>

      <div className="flex items-center justify-end">{rightSection}</div>
    </nav>
  );
}
